import { isCopilotPlanningTool } from "@/features/copilot/lib/copilot-tool-labels";

interface ThinkingPart {
  type: string;
  text?: string;
  toolName?: string;
  status?: { type: string };
}

interface ThinkingMessage {
  role: string;
  parts: readonly ThinkingPart[];
}

/// The dots cover every silent stretch of a run: before the first token, and while the model
/// plans between steps. They step aside when something else on screen already shows progress,
/// which is text arriving or a data read row with its own spinner.
export function isCopilotThinkingVisible(
  running: boolean,
  latest: ThinkingMessage | undefined,
): boolean {
  if (!running) return false;
  if (!latest || latest.role !== "assistant") return true;
  const tail = latest.parts.at(-1);
  if (!tail) return true;
  if (tail.type === "text") return (tail.text ?? "").trim() === "";
  if (tail.type === "tool-call" && tail.toolName && !isCopilotPlanningTool(tail.toolName)) {
    return tail.status?.type !== "running";
  }
  return true;
}
